export default __webpack_public_path__ + "static/media/left-side50.458a44ee.png";